import * as React from "react";
import { Box, Typography } from "@mui/material";
import { platformPageSubtitleSx, platformPageTitleSx } from "../tickitPlatformTheme";

export default function PlatformPageHeader({ title, subtitle, actions }) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        alignItems: { xs: "flex-start", sm: "flex-start" },
        justifyContent: "space-between",
        gap: 2,
        mb: 3.5,
      }}
    >
      <Box>
        <Typography component="h1" sx={platformPageTitleSx}>
          {title}
        </Typography>
        {subtitle && (
          <Typography component="p" sx={platformPageSubtitleSx}>
            {subtitle}
          </Typography>
        )}
      </Box>
      {actions && (
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, flexShrink: 0 }}>{actions}</Box>
      )}
    </Box>
  );
}
